module.exports = __webpack_public_path__ + "img/deepwater4.8999018c.png";